// import React from 'react'

// const HiredListTable = ({hiredList}) => {
//   return (
//     <div className="bg-white shadow-sm rounded-lg p-6">
//             <h2 className="text-lg font-semibold text-gray-900 mb-6">Hired Applicants</h2>
//             <table className="min-w-full divide-y divide-gray-200">
//               <thead className="bg-gray-50">
//                 <tr>
//                   {["S/N", "Employee Name", "Position", "Date Employed", "Action"].map((header) => (
//                     <th
//                       key={header}
//                       className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
//                     >
//                       {header}
//                     </th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody className="bg-white divide-y divide-gray-200">
//                 {hiredList?.map((employee, index) => (
//                   <tr key={index}>
//                     <td className="px-6 py-4 text-sm text-gray-500">{index + 1}</td>
//                     <td className="px-6 py-4 text-sm text-gray-900 font-medium">
//                       {employee.applicantName}
//                     </td>
//                     <td className="px-6 py-4 text-sm text-gray-500">{employee.position}</td>
//                     <td className="px-6 py-4 text-sm text-gray-500">
//                       {employee.dateOfEmployment}
//                     </td>
//                     <td className="px-6 py-4 text-sm">
//                       <button className="px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-md hover:bg-blue-700 transition-colors">
//                         Pay
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//   )
// }

// export default HiredListTable











import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { ArrowPathIcon } from '@heroicons/react/24/outline';

const HiredListTable = ({ hiredList: initialHiredList }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [hiredList, setHiredList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchHiredApplicants = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${process.env.REACT_APP_API_URL}application/applications`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const applications = response.data.received || [];
        const hired = applications.filter(app => app.status === 'Accepted');
        setHiredList(hired);
        console.log(hired, "Hired Applicants");
      } catch (error) {

        console.log(error)
        // toast.error(error.response?.data?.message || 'Failed to load hired applicants');
      } finally {
        setLoading(false);
      }
    };

    if (initialHiredList) {
      setHiredList(initialHiredList);
      setLoading(false);
    } else {
      fetchHiredApplicants();
    }
  }, [initialHiredList]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  // Filter hiredList based on searchTerm
  const filteredHiredList = hiredList?.filter((application) =>
    application?.applicant?.some((userId) =>
      userId.toString().includes(searchTerm.toLowerCase()) // Adjust based on how applicant names are fetched
    ) || application.position.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (loading) {
    return (
      <div className="bg-white shadow-sm rounded-lg p-6 flex justify-center items-center h-64">
        <ArrowPathIcon className="h-10 w-10 animate-spin text-blue-500" />
      </div>
    );
  }

  return (
    <div className="bg-white shadow-sm rounded-lg p-6">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-lg font-semibold text-gray-900">Hired Applicants</h2>
        <input
          type="text"
          placeholder="Search by employee name or position..."
          value={searchTerm}
          onChange={handleSearchChange}
          className="p-2 text-sm text-gray-600 border border-gray-300 rounded-md outline-none focus:border-blue-500 transition-colors w-1/3"
        />
      </div>
      {hiredList.length === 0 && !loading && (
        <p className="text-center text-gray-500">No hired applicants found.</p>
      )}
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            {["S/N", "Employee Name", "Position", "Date Employed", "Action"].map((header) => (
              <th
                key={header}
                className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {filteredHiredList?.map((application, index) => {
            const applicantId = application.applicant[0]; // Assuming single applicant per application
            return (
              <tr key={application._id}>
                <td className="px-6 py-4 text-sm text-gray-500">{index + 1}</td>
                <td className="px-6 py-4 text-sm text-gray-900 font-medium">
                  {application.applicantName || 'Loading...'} {/* Fetch name if needed */}
                </td>
                <td className="px-6 py-4 text-sm text-gray-500">{application.position}</td>
                <td className="px-6 py-4 text-sm text-gray-500">
                  {application.dateHired || 'N/A'}
                </td>
                <td className="px-6 py-4 text-sm">
                  <button className="px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-md hover:bg-blue-700 transition-colors">
                    Pay
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default HiredListTable;